export const PLANNED_PATH_TOPICS = ["/plan_smoothed", "/plan"] as const;

export const navigationTopicsInfo = {
    plannedPath: {
        topics: PLANNED_PATH_TOPICS,
        default: [] as { x: number; y: number }[],
    },
};
